// extracted by mini-css-extract-plugin
export default {"cartIcon":"CartButtonSmall_cartIcon__S+Z6h"};